import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
import { SearchTableQuery } from 'owa-mail-list-search';
import { getSelectedTableView } from 'owa-mail-list-store';
import { SearchScopeKind } from 'owa-search-service';

/**
 * Determine if the search is in a shared folder.
 */
export default function isSharedFolderSearch(): boolean {
    const searchTableQuery = getSelectedTableView().tableQuery as SearchTableQuery;

    if (searchTableQuery.searchScope) {
        return searchTableQuery.searchScope.kind === SearchScopeKind.SharedFolders;
    } else {
        // Until user performs a search the searchScope does not get set. So, we need this fallback check.
        const { folderId } = searchTableQuery;
        return folderId && isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE);
    }
}
